import * as Actions from './ActionTypes'

const INGREDIENT_PRICE={
    salad:20,
    meat:40,
    cheese:30
}

const InitailState={
    ingredient:[
        {type:'salad',amount:0},
        {type:'meat',amount:0},
        {type:'cheese',amount:0},
    ],
    orders:[],
    orderErr:false,
    orderLoading:true,
    totalPrice:80,
    purchase:false,
    token:null,
    userId:null,
    authLoading:false,
    authErrMsg:null,
}

export const Reducer=(state=InitailState,action)=>{
    let ingredientCpy=[...state.ingredient];
    switch(action.type){
        case Actions.ADD_INGREDIENT:
            for(let item of ingredientCpy){
                if(item.type===action.payload){
                    item.amount++;
                }
            }
            return{
                ...state,
                ingredient:ingredientCpy,
                totalPrice:state.totalPrice+INGREDIENT_PRICE[action.payload]
            }
        case Actions.REMOVE_INGREDIENT:
            for(let item of ingredientCpy){
                if(item.type===action.payload){
                    if (item.amount <= 0) return state;
                    item.amount--;
                }
            }
            return{
                ...state,
                ingredient:ingredientCpy,
                totalPrice:state.totalPrice-INGREDIENT_PRICE[action.payload]
            }
        case Actions.UPDATE_PRICE:
            let sum=state.ingredient.reduce((sum,element)=>{
                return sum+=element.amount;
            },0);
            return {
                ...state,
                purchase:sum>0
            } 
        case Actions.RESET_INGREDIENT:  
        return {
            ingredient:[
            {type:'salad',amount:0},
            {type:'meat',amount:0},
            {type:'cheese',amount:0},
        ],
        totalPrice:80,
        purchase:false,
    }
    case Actions.LOAD_ORDERS:
        let orders=[]
        for(let key in action.payload){
            orders.push({
                ...action.payload[key],
                id:key,
                }   
            )
        }
        return{
            ...state,
            orders:orders,
            orderLoading:false,
        }
    case Actions.LOAD_ORDERS_FAILED:
        return {
            ...state,
            orderErr:true,
            orderLoading:false,
        }
    //Auth case 
    case Actions.AUTH_SUCCESS:
        console.log(action.payload);
        return{
            ...state,
            token:action.payload.token,
            userId:action.payload.userId
        }
    case Actions.AUTH_LOGOUT:
        return{
            ...state,
            token:null,
            userId:null,
            authLoading:false,
            authErrMsg:null
        }
    case Actions.AUTH_LOADING:
        return{
            ...state,
            authLoading:action.payload
        }
    case Actions.AUTH_FAILED:
        return{
            ...state,
            authLoading:false,
            authErrMsg:action.payload
        }
        default:
            return state;
    }
}